<template>
  <div class="container-fluid">
    <!-- Config Options -->
    <b-card no-body class="mt-3">

      <b-tabs pills card>
        <b-tab title="EMail Server" active>
          <b-row class="mt-3">
            <b-col cols="3">
              <b-form @submit="saveEMailServerConfig()">
                <b-form-group id="g-email-host"
                              label="EMail Server Host"
                              label-for="email_host">
                  <b-form-input id="email_host"
                                type="text"
                                v-model="email.host"
                                required
                                placeholder="Enter email server host">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="g-email-port"
                              label="EMail Server Port"
                              label-for="email_port">
                  <b-form-input id="email_port"
                                type="number"
                                v-model="email.port"
                                required
                                placeholder="Enter email server port">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="g-email-user"
                              label="User Name"
                              label-for="email_user">
                  <b-form-input id="email_user"
                                type="email"
                                v-model="email.user"
                                placeholder="Enter email address">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="g-email-pass"
                              label="Password"
                              label-for="email_pass">
                  <b-form-input id="email_pass"
                                type="password"
                                v-model="email.pass"
                                placeholder="Enter password">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="exampleGroup4">
                  <b-form-checkbox id="checkbox1"
                                   v-model="email.tls"
                                   :value="true"
                                   :unchecked-value="false">
                    Use TLS/SSL
                  </b-form-checkbox>
                </b-form-group>
                <b-alert variant="success" dismissible :show="emailSaveOkay">Saved</b-alert>
                <b-button type="submit" variant="primary"><i class="fa fa-save"></i> Save</b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="File Server" active>
          <b-row class="mt-3">
            <b-col cols="3">
              <b-form @submit="saveFileServerConfig()">
                <b-form-group id="g-ft"
                              label="File Server Type"
                              label-for="ft">
                  <b-form-select id="ft"
                                 v-model="file.serverType"
                                 required
                                 placeholder="Enter File server host">
                    <option :value="null">Please select an option</option>
                    <option value="smb">Windows Server</option>
                    <option value="nfs">NFS Server</option>
                    <option value="file">Local Folder</option>
                  </b-form-select>
                </b-form-group>
                <b-form-group id="g-domain"
                              label="File Server Domain"
                              label-for="file_domain">
                  <b-form-input id="file_domain"
                                type="text"
                                v-model="file.domain"
                                required
                                placeholder="Enter File server Domain">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="g-host"
                              label="File Server Host"
                              label-for="file_host">
                  <b-form-input id="file_host"
                                type="text"
                                v-model="file.host"
                                required
                                placeholder="Enter File server host">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="g-port"
                              label="File Server Path"
                              label-for="file_path">
                  <b-form-input id="file_path"
                                type="text"
                                v-model="file.path"
                                required
                                placeholder="Enter File server path">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="g-file-user"
                              label="User Name"
                              label-for="file_user">
                  <b-form-input id="file_user"
                                type="text"
                                v-model="file.user"
                                placeholder="Enter user name">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="g-file-pass"
                              label="Password"
                              label-for="file_pass">
                  <b-form-input id="file_pass"
                                type="password"
                                v-model="file.pass"
                                placeholder="Enter password">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="g-update-system"
                              label="Update Server"
                              label-for="update_server">
                  <b-form-input id="update_server"
                                type="text"
                                v-model="file.updateSystem"
                                required
                                placeholder="Enter Update System">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="g-update-user"
                              label="Update System User Name"
                              label-for="update_user">
                  <b-form-input id="update_user"
                                type="text"
                                v-model="file.updateUser"
                                placeholder="Enter Update System user name">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="g-update-pass"
                              label="Password"
                              label-for="update_pass">
                  <b-form-input id="update_pass"
                                type="password"
                                v-model="file.updatePass"
                                placeholder="Enter Update System password">
                  </b-form-input>
                  <b-form-group id="g-update-procedure"
                                label="Update Procedure"
                                label-for="update_procedure">
                    <b-form-input id="update_procedure"
                                  type="text"
                                  v-model="file.updateProcedure"
                                  required
                                  placeholder="Enter Update Procedure">
                    </b-form-input>
                  </b-form-group>
                </b-form-group>
                <b-alert variant="success" dismissible :show="fileSaveOkay">Saved</b-alert>
                <b-btn-group>
                  <b-button type="submit" variant="primary"><i class="fa fa-save"></i> Save</b-button>
                  <b-button type="button" @click.prevent="checkFS" variant="info"><i class="fa fa-check"></i> Check
                  </b-button>
                </b-btn-group>
              </b-form>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="SMS Server">
          <b-row class="mt-3">
            <b-col cols="3">
              <b-form @submit="saveSMSServerConfig()">
                <b-form-group id="g-sms-host"
                              label="SMS Server Host"
                              label-for="sms_host">
                  <b-form-input id="sms_host"
                                type="text"
                                v-model="sms.host"
                                required
                                placeholder="Enter email server host">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="g-sms-user"
                              label="User Name"
                              label-for="sms_user">
                  <b-form-input id="sms_user"
                                type="email"
                                v-model="sms.user"
                                placeholder="Enter email address">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="g-sms-pass"
                              label="Password"
                              label-for="sms_pass">
                  <b-form-input id="sms_pass"
                                type="password"
                                v-model="sms.pass"
                                placeholder="Enter password">
                  </b-form-input>
                </b-form-group>
                <b-alert variant="success" dismissible :show="smsSaveOkay">Saved</b-alert>
                <b-button type="submit" variant="primary"><i class="fa fa-save"></i> Save</b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Daily EMail Notifications">
          <b-row class="mt-3">
            <b-col>
              <b-form>
                <b-form-group label="POD Pending Notification">
                  <b-form-checkbox-group id="podPending0" name="podPending" v-model="notification.podPending">
                    <b-form-checkbox value="ADMIN">Administrator</b-form-checkbox>
                    <b-form-checkbox value="REGULAR_USER">Company User</b-form-checkbox>
                    <b-form-checkbox value="TRANSPORTER">Transporter</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
                <b-form-group label="POD Dispute Notification">
                  <b-form-checkbox-group id="podPending1" name="podDispute" v-model="notification.podDispute">
                    <b-form-checkbox value="ADMIN">Administrator</b-form-checkbox>
                    <b-form-checkbox value="REGULAR_USER">Company User</b-form-checkbox>
                    <b-form-checkbox value="TRANSPORTER">Transporter</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
                <b-form-group label="Undelivered & E-Waybill Expiry">
                  <b-form-checkbox-group id="podPending2" name="ewbExpiry" v-model="notification.ewbExpiry">
                    <b-form-checkbox value="ADMIN">Administrator</b-form-checkbox>
                    <b-form-checkbox value="REGULAR_USER">Company User</b-form-checkbox>
                    <b-form-checkbox value="TRANSPORTER">Transporter</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
                <b-alert variant="success" dismissible :show="notificationSaveOkay">Saved</b-alert>
                <b-button type="button" variant="primary" @click="saveEMailNotifications()"><i class="fa fa-save"></i>
                  Save
                </b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="EMail Alerts">
          <b-row class="mt-3">
            <b-col>
              <b-form>
                <b-form-group label="Dispute Raised">
                  <b-form-checkbox-group id="disputeRaised" name="disputeRaised" v-model="alerts.disputeRaised">
                    <b-form-checkbox value="ADMIN">Administrator</b-form-checkbox>
                    <b-form-checkbox value="REGULAR_USER">Company User</b-form-checkbox>
                    <b-form-checkbox value="TRANSPORTER">Transporter</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
                <b-form-group label="Dispute Resolved">
                  <b-form-checkbox-group id="disputeResolved" name="disputeResolved" v-model="alerts.disputeResolved">
                    <b-form-checkbox value="ADMIN">Administrator</b-form-checkbox>
                    <b-form-checkbox value="REGULAR_USER">Company User</b-form-checkbox>
                    <b-form-checkbox value="TRANSPORTER">Transporter</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
                <b-form-group label="Dispute Updated">
                  <b-form-checkbox-group id="disputeComment" name="disputeComment" v-model="alerts.disputeComment">
                    <b-form-checkbox value="ADMIN">Administrator</b-form-checkbox>
                    <b-form-checkbox value="REGULAR_USER">Company User</b-form-checkbox>
                    <b-form-checkbox value="TRANSPORTER">Transporter</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
                <b-alert variant="success" dismissible :show="alertSaveOkay">Saved</b-alert>
                <b-button type="button" @click="saveEmailAlerts()" variant="primary"><i class="fa fa-save"></i> Save
                </b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Misc Configs">
          <b-row class="mt-3">
            <b-col>
              <b-form>

                <table class="table table-borderless">
                  <thead class="thead-dark">
                  <tr>
                    <th>Key</th>
                    <th>Value</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="kv of kvs" :key="kv.theKey">
                    <td>
                      <input type="text" v-model="kv.theKey" class="form-control"/>
                    </td>
                    <td>
                      <textarea v-model="kv.theValue" class="form-control"></textarea>
                    </td>
                    <td>
                      <div class="btn-group">
                        <button class="btn btn-success" @click="saveKV(kv)">
                          <i class="fa fa-save"></i>
                        </button>
                        <button class="btn btn-danger" @click="delKV(kv)">
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-button type="button" variant="info" @click="addKV()"><i class="fa fa-plus"></i> Add</b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Actions">
          <b-row class="mt-3 text-center" align-h="center" align-v="center">
            <b-col>
              <b-button variant="primary" @click="runTranslogImport()" :disabled="importRunning">
                <span v-if="!importRunning">Run Translog Import</span>
                <span v-if="importRunning">Translog Import in progress</span>
              </b-button>
            </b-col>
            <b-col>
              <b-button variant="warning" @click="runTranslogUpdate()" :disabled="updateRunning">
                <span v-if="!updateRunning">Run Translog Update</span>
                <span v-if="updateRunning">Translog Update in progress</span>
              </b-button>
            </b-col>
            <b-col>
              <b-button variant="danger" @click="clearCache()">
                Clear Cache
              </b-button>
            </b-col>
            <b-col>
              <b-button variant="info" @click="triggerPOD()" :disabled="podRunning">
                <span v-if="!podRunning">Download POD</span>
                <span v-if="podRunning">POD Download in progress</span>
              </b-button>
            </b-col>
            <b-col>
              <b-button variant="secondary" @click="updateTRLocation()">
                <span>Update Transporter Locations</span>
              </b-button>
            </b-col>
            <b-col>
              <b-button variant="warning" @click="updatePartB()" :disabled="ewbRunning">
                <span>Update Part-B</span>
              </b-button>
            </b-col>
          </b-row>
        </b-tab>

      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ConfigPage',
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (!this.$store.state.loggedIn) {
        console.log('Not Logged-in')
        this.$router.push('login')
      }
      this.loadConfig()
    }, _ => {
      console.error('isLoggedIn Failed, lets go to login')
      this.$router.push('login')
    })
    this.kvs = this.$store.state.keyValues
    this.kvs.filter(kv => kv.theKey === 'EMAIL_NOTIFICATION')
      .forEach(kv => {
        this.notification = JSON.parse(kv.theValue)
      })
    this.kvs.filter(kv => kv.theKey === 'EMAIL_ALERT')
      .forEach(kv => {
        this.alerts = JSON.parse(kv.theValue)
      })
  },
  computed: {
    logSrc () {
      return `/inpod/app/log?x-auth-token=${this.$store.state.accessToken}`
    }
  },
  data () {
    return {
      logLevels: [
        {'value': 'TRACE', 'text': 'TRACE'},
        {'value': 'DEBUG', 'text': 'DEBUG'},
        {'value': 'INFO', 'text': 'INFO'},
        {'value': 'WARN', 'text': 'WARN'}
      ],
      ebeanLogLevel: 'WARN',
      email: {
        host: '',
        port: null,
        tls: true,
        user: '',
        pass: ''
      },
      sms: {
        host: '',
        user: '',
        pass: ''
      },
      file: {
        host: '',
        domain: '',
        path: '',
        user: '',
        pass: '',
        serverType: '',
        updateSystem: '',
        updateUser: '',
        updatePass: '',
        updateProcedure: ''
      },
      emailSaveOkay: false,
      importRunning: false,
      updateRunning: false,
      ewbRunning: false,
      deletePodRunning: false,
      podRunning: false,
      smsSaveOkay: false,
      fileSaveOkay: false,
      notificationSaveOkay: false,
      alertSaveOkay: false,
      kvSaveOkay: false,
      notification: {
        podPending: [],
        podDispute: [],
        ewbExpiry: []
      },
      alerts: {
        disputeRaised: []
      },
      kvs: []
    }
  },
  methods: {
    async checkFS () {
      axios.post('/misc/check-fs')
        .then(resp => {
          console.log('file server check ...', resp)
          alert(' FileServerConfig Check = ' + JSON.stringify(resp.data))
        }, err => {
          console.error('error in fs check', err)
          alert('error in FileServerConfig Check' + JSON.stringify(err))
        })
    },
    ebeanLevelChanged: function () {
      axios.post(`/misc/debug/ebean?level=${this.ebeanLogLevel}`)
        .then(_ => {
          console.log('level changed')
        }, err => {
          console.error('level change fail', err)
        })
    },
    triggerPOD: function () {
      axios.post('/misc/pod-download')
        .then(resp => {
          console.log('started ...', resp)
          this.podRunning = true
        }, err => {
          alert('an import is already scheduled')
          console.error('error in trigger of import', err)
        })
    },
    updateTRLocation: function () {
      axios.post('/misc/update-transporter-location')
        .then(resp => {
          console.log('started ...', resp)
        }, err => {
          console.error('error in trigger of import', err)
        })
    },
    runTranslogImport: function () {
      axios.post('/misc/import')
        .then(resp => {
          console.log('started ...', resp)
          this.importRunning = true
        }, err => {
          alert('an import is already scheduled')
          console.error('error in trigger of import', err)
        })
    },
    clearCache: function () {
      axios.post('/misc/clear-cache')
        .then(resp => {
          console.log('clearing cache..', resp)
        }, err => {
          console.error('error in clearing cache', err)
        })
    },
    runTranslogUpdate: function () {
      axios.post('/misc/update')
        .then(resp => {
          console.log('started ...', resp)
          this.updateRunning = true
        }, err => {
          alert('an import is already scheduled')
          console.error('error in trigger of import', err)
        })
    },
    updatePartB: function () {
      axios.post('/misc/ewb')
        .then(resp => {
          console.log('started ...', resp)
          this.ewbRunning = true
        }, err => {
          alert('an import is already scheduled')
          console.error('error in trigger of import', err)
        })
    },
    deleteAutoDownloadedPOD: function () {
      if (confirm('this is dangerous, do you want to continue?')) {
        axios.post('/misc/purge-auto-downloaded-pod')
          .then(resp => {
            console.log('started ...', resp)
            this.deletePodRunning = true
          }, err => {
            alert('a delete is already scheduled')
            console.error('error in trigger of import', err)
          })
      }
    },
    addKV: function () {
      this.kvs.push({theKey: '', theValue: ''})
    },
    loadConfig: function () {
      axios.get('/pod-app/config/email')
        .then(resp => {
          this.email = resp.data
        }, error => {
          console.error('error in fetching email config', error)
        })
      axios.get('/pod-app/config/file')
        .then(resp => {
          this.file = resp.data
        }, error => {
          console.error('error in fetching email config', error)
        })
      axios.get('/misc/purge-auto-downloaded-pod')
        .then(resp => {
          this.deletePodRunning = resp.data.running
        }, error => {
          console.error('error in fetching email config', error)
        })
      axios.get('/misc/pod-download')
        .then(resp => {
          this.podRunning = resp.data.running
        }, error => {
          console.error('error in fetching email config', error)
        })
      axios.get('/misc/import')
        .then(resp => {
          this.importRunning = resp.data.running
        }, error => {
          console.error('error in fetching email config', error)
        })
      axios.get('/misc/update')
        .then(resp => {
          this.updateRunning = resp.data.running
        }, error => {
          console.error('error in fetching email config', error)
        })
      axios.get('/misc/ewb')
        .then(resp => {
          this.ewbRunning = resp.data.running
        }, error => {
          console.error('error in fetching email config', error)
        })

      axios.get('/pod-app/key-values')
        .then(resp => {
          this.kvs = resp.data
          this.kvs.forEach(kv => {
            this.$store.commit('addkeyValue', kv)
          })
        }, err => {
          console.error('error in fetching keyvalues', err)
        })
    },
    saveSMSServerConfig: function () {
      console.log('saved')
    },
    saveEMailServerConfig: function () {
      this.emailSaveOkay = false
      axios.post('/pod-app/config/email', this.email)
        .then(_ => {
          this.emailSaveOkay = true
        }, error => {
          console.error('error in saving email config', error)
        })
    },
    saveFileServerConfig: function () {
      this.fileSaveOkay = false
      axios.post('/pod-app/config/file', this.file)
        .then(_ => {
          this.fileSaveOkay = true
        }, error => {
          console.error('error in saving email config', error)
        })
    },
    saveEMailNotifications: function () {
      console.log('saving', this.notification)
      this.notificationSaveOkay = false
      axios.post('/pod-app/key-values', {theKey: 'EMAIL_NOTIFICATION', theValue: JSON.stringify(this.notification)})
        .then(_ => {
          this.notificationSaveOkay = true
        }, error => {
          console.error('error in saving email notification', error)
        })
    },
    saveEmailAlerts: function () {
      console.log('saving', this.alerts)
      this.alertSaveOkay = false
      axios.post('/pod-app/key-values', {theKey: 'EMAIL_ALERTS', theValue: JSON.stringify(this.alerts)})
        .then(_ => {
          this.alertSaveOkay = true
        }, error => {
          console.error('error in saving email alert', error)
        })
    },
    saveKV: function (kv) {
      axios.post('/pod-app/key-values', kv)
        .then(_ => {
          this.$store.commit('addKeyValue', kv)
        }, error => {
          console.error('error in saving KV', error, kv)
        })
    },
    delKV: function (kv) {
      axios.post('/pod-app/key-values/delete', kv)
        .then(_ => {
          this.$store.commit('removeKeyValue', kv)
        }, error => {
          console.error('error in saving KV', error, kv)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/ConfigPage.vue